import { API_BASE_URL } from '../config';
import type { FormFlowDefinition } from '../types/formFlow';

export async function fetchFormDefinition(formCode: string): Promise<FormFlowDefinition | null> {
  if (!API_BASE_URL || !formCode?.trim()) return null;
  const url = `${API_BASE_URL}/api/form-definitions?formCode=${encodeURIComponent(formCode.trim())}`;
  const r = await fetch(url);
  if (!r.ok) return null;
  return r.json() as Promise<FormFlowDefinition>;
}
